import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';
import '../styles/ForgotPassword.css';

export default function ForgotPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    setError(null);

    if (!token) {
      setError('Reset link is missing or invalid. Request a new password reset email.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      const response = await authService.resetPassword(password, token);
      if (response.success) {
        alert('Password updated successfully');
        window.location.href = '/';
      } else {
        setError(response.message || 'Failed to update password');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <div className="forgot-password-icon">🔒</div>

        <h2>Reset Password</h2>

        <p className="forgot-password-subtitle">
          Enter your new password below to secure your account.
        </p>

        {!token && (
          <p style={{ color: '#b91c1c', marginBottom: 12 }}>
            This page needs a valid reset link from your email.
          </p>
        )}

        {error && (
          <p style={{ color: '#b91c1c', marginBottom: 12 }}>{error}</p>
        )}

        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <button
          className="forgot-password-bttn"
          onClick={submit}
          disabled={loading || !token}
        >
          {loading ? 'Updating...' : 'Update Password'}
        </button>
      </div>
    </div>
  );
}
